import { useContext } from 'react';
import PageHeader from '../../components/pageHeader/pageHeader';
import SideNav from '../../components/sideNav/sideNav';
import MenuOptions from '../../components/menu/menu';
import { UserContext } from '../../shared/context/userContext';
import { MenuIndex } from '../../components/menu/menu.enum';
import { viewsUseStyles } from '../views.styles';
import ClientConfigDetails from './clientConfigDetails/clientConfigDetails';

const ClientConfig = () => {
  const { userData } = useContext(UserContext);
  const classes = viewsUseStyles();

  return (
    <>
      <SideNav
        menu={
          <MenuOptions
            type={MenuIndex.Overview}
            orientation={'vertical'}
            divider={true}
            navLinkStyle={classes.globalSideNavMenu}
            navLinkActiveStyle={classes.globalSideNavMenuActive}
            itemStyle={classes.globalSideNavMenuItem}
            textStyle={classes.globalSideNavTextItem}
            permissions={userData.user.role.permissions}
          />
        }
      />
      <div className={classes.globalViewContent}>
        <PageHeader title="Client config settings" />
        <ClientConfigDetails />
      </div>
    </>
  );
};

export default ClientConfig;
